import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export const useUnreadMessages = (enabled = true) => {
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await api.get('/chat/unread-count');
      setUnreadCount(res.data?.count ?? 0);
    } catch {
      setUnreadCount(0);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setUnreadCount(0);
      return;
    }
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, [enabled, fetchUnreadCount]);

  return { unreadCount, hasUnread: unreadCount > 0, refetch: fetchUnreadCount };
};
